import Home from '../components/Home'
import ProductFormSku from '../components/ProductFormSku'
import ProductFormEan from '../components/ProductFormEan'
import ProductFormCamera from '../components/ProductFormCamera'
import SearchFormShelf from '../components/SearchFormShelf'

export default [
  { path: '/', name: 'Home', component: Home },
  { path: '/sku', name: 'ProductFormSku', component: ProductFormSku },
  { path: '/ean', name: 'ProductFormEan', component: ProductFormEan },
  { path: '/camera', name: 'ProductFormCamera', component: ProductFormCamera },
  { path: '/shelf', name: 'SearchFormShelf', component: SearchFormShelf }
]



// WEBPACK FOOTER //
// ./src/router/routes.js